import React from 'react';
import { DownloadOverlay } from '../player/components/DownloadOverlay';
import type { KollabDownloadOverlayProps } from './types';

const DEFAULT_PREVENT_MESSAGE =
  "Your browser can't play this file and you don't have permission to download it.";

/**
 * Standalone download overlay used by `renderPlayer()`'s catch-all branch
 * (file types that aren't video / audio / image / PDF / comment stream / text).
 *
 * Thin wrapper over the shared `DownloadOverlay` component already used inside
 * KollabPlayer / KollabImageViewer, sized to fill the host container so it
 * matches the legacy `createUnableToPlayMessage()` block.
 */
const KollabDownloadOverlay = React.memo(function KollabDownloadOverlay(
  props: KollabDownloadOverlayProps,
) {
  const {
    fileTitle,
    fileSize,
    fileTypeName,
    iconUrl,
    downloadUrl,
    preventDownload,
    preventDownloadMessage,
    width,
    height,
  } = props;

  // Fill the parent stage (set by PlayerSlot's NON_MEDIA_STAGE_STYLE to a
  // 16:9 box sized from the column width).
  const containerStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    flex: '1 1 auto',
    position: 'relative',
    border: 'thin solid',
    textAlign: 'center',
  };

  return (
    <div id="player_container" style={containerStyle}>
      <DownloadOverlay
        visible
        message={preventDownloadMessage || DEFAULT_PREVENT_MESSAGE}
        canDownload={!preventDownload}
        downloadUrl={downloadUrl || undefined}
        title={fileTitle}
        fileTypeName={fileTypeName}
        fileSize={fileSize}
        fileIconUrl={iconUrl}
      />
    </div>
  );
});

export default KollabDownloadOverlay;
